import {
    BackButton,
    Divider,
    Form,
    FormDropDown,
    FormInput,
    Header,
    setAttributeEntity,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileDwellingScheduledItem = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    return (
        <React.Fragment>
            <BackButton clickEvent={props.backEvent} />
            <Divider top={sizes.md} />
            <Header
                size={sizes.md}
                textAlign={alignments.left}
                text={<FormattedMessage id='Profile_Dwellings_ScheduledItem.scheduledItem' />}
            />
            <Form
                label={<FormattedMessage id='Profile_Dwellings_ScheduledItem.scheduledItemDetails' />}
                allowEdit={props.allowEdit}
                saveEvent={() => props.doUpsertPolicy()}
                cancelEvent={() => props.doGetPolicy()}
            >
                <FormDropDown
                    label={<FormattedMessage id='Profile_Dwellings_ScheduledItem.type' />}
                    value={props.scheduledItem?.type}
                    references={props.reference.references?.ScheduledItems}
                    referencesEvent={() => props.reference.doGetReferences('ScheduledItems')}
                    changeEvent={(value) =>
                        setAttributeEntity(`${props.dotProp}type`, value, props.doReducePolicyElement)
                    }
                    allowEdit
                />
                <FormInput
                    label={<FormattedMessage id='Profile_Dwellings_ScheduledItem.insuredValue' />}
                    value={props.scheduledItem?.insuredValue?.value}
                    changeEvent={(value) => {
                        props.doReducePolicyElement({ code: `${props.dotProp}insuredValue.value`, value });
                        props.doReducePolicyElement({ code: `${props.dotProp}insuredValue.currency`, value: 'cad' });
                    }}
                    allowEdit
                />
            </Form>
        </React.Fragment>
    );
};

export default ProfileDwellingScheduledItem;
